export type IncoTermDescription = {
  abbreviation: string
  description: string
}

export const INCOTERM_CODES = [
  'EXW',
  'FCA_LW',
  'FCA_T',
  'FAS',
  'FOB',
  'CFR',
  'CIF',
  'CPT',
  'CIP',
  'DPU',
  'DAP',
  'DDP',
] as const

export type IncoTermsCode = (typeof INCOTERM_CODES)[number]

export const isValidIncoTermsCode = (code: string): code is IncoTermsCode =>
  INCOTERM_CODES.some((item) => item === code)

export const INCOTERMS_DESCRIPTIONS: Record<IncoTermsCode, IncoTermDescription> = {
  EXW: {
    abbreviation: 'EXW',
    description: 'Ex Works',
  },
  FCA_LW: {
    abbreviation: 'FCA',
    description: 'Free Carrier - Shipper',
  },
  FCA_T: {
    abbreviation: 'FCA',
    description: 'Free Carrier - Terminal',
  },
  FAS: {
    abbreviation: 'FAS',
    description: 'Free Alongside Ship',
  },
  FOB: {
    abbreviation: 'FOB',
    description: 'Free On Board',
  },
  CFR: {
    abbreviation: 'CFR',
    description: 'Cost and Freight',
  },
  CIF: {
    abbreviation: 'CIF',
    description: 'Cost, Insurance and Freight',
  },
  CPT: {
    abbreviation: 'CPT',
    description: 'Carriage Paid To',
  },
  CIP: {
    abbreviation: 'CIP',
    description: 'Carriage and Insurance Paid to',
  },
  DPU: {
    abbreviation: 'DPU',
    description: 'Delivered At Place Unloaded',
  },
  DAP: {
    abbreviation: 'DAP',
    description: 'Delivered At Place',
  },
  DDP: {
    abbreviation: 'DDP',
    description: 'Delivered Duty Paid',
  },
}
